<template>
  <div class="module pageContainer">
      <div class="resultArea u-border">
        <div class="tableList">
            <el-table
            empty-text="抱歉，暂无相关数据"
            style="width: 100%"
            v-loading="tableLoad"
            :data="tableData">
            <el-table-column type="index" label="序号" width="55"></el-table-column>
            <el-table-column prop="company" label="公司名称"></el-table-column>
            <el-table-column prop="name" label="联系人" ></el-table-column>
            <el-table-column prop="phone" label="手机号" ></el-table-column>
            <el-table-column prop="manage_category" label="经营类目" ></el-table-column>
            <el-table-column prop="manage_attribute" label="经营属性" ></el-table-column>
            <el-table-column prop="gen_time" label="发布时间" ></el-table-column>
            </el-table>
        </div>
        <PaginationCom
            :pageData="pageData"
            @size-change="onPageSizeChange"
            @current-change="onCurrentPageChange">
        </PaginationCom>
    </div>
  </div>
</template>

<script>
    import { PAGINATION } from '@/helpers/baseData';
    import { getCompanyData } from '@/api/apii';
    import PaginationCom from '@/views/_common/PaginationCom';
    export default {
        name: 'company',
        inject: ['myMessage'],
        components: {
          'PaginationCom': PaginationCom
        },
        data () {
          return {
            pageData: {
            total: 5,
            pageSize: PAGINATION.pageSize,
            currentPage: 1
          },
          tableData: [],
          tableLoad: false
          };
        },
        methods: {
          requestData () {
            getCompanyData(this.handleFormData())
              .then(res => {
                this.handleData(res);
              })
              .catch(() => {
                this.myMessage.megError('查询失败,请重试');
              });
          },
          handleData (res) {
            this.pageData.total = res.count;
            this.tableData = res.datalist;
            this.tableData.forEach(item => {
              item.gen_time = item.gen_time.split(' ')[0];
            });
          },
          handleFormData () {
            const requestData = {
              page: this.pageData.currentPage,
              limit: this.pageData.pageSize,
              orderBy: this.tableOrderBy,
              where: []
            };
            return requestData;
          },
          onCurrentPageChange (page) {
            this.pageData.currentPage = page;
            this.requestData();
          },
          onPageSizeChange (size) {
            this.pageData.pageSize = size;
            this.pageData.currentPage = 1;
            this.requestData();
          }
        },
        created () {
          this.requestData();
        }
    };
</script>

<style>

</style>
